module.exports = __webpack_public_path__ + "media/PAG86-08.f360bfd0.mp3";